import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useOnboardingProgress } from '../../hooks/useOnboardingQueries';
import { OnboardingChecklist } from './OnboardingChecklist';

export function DashboardPage() {
  const { t } = useTranslation('ats');
  const { data, isLoading, error } = useOnboardingProgress();

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 py-12 text-sm text-gray-500">
        <Loader2 className="h-4 w-4 animate-spin" />
        {t('onboarding.loading')}
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="rounded-md border border-red-200 bg-red-50 p-4 text-sm text-red-700">
        {t('onboarding.loadError')}
      </div>
    );
  }

  // Card shown until the user explicitly dismisses it (via the X button or
  // the "Done" button after all steps complete).
  const showChecklist = !data.dashboard_dismissed;

  return (
    <div className="space-y-6">
      {showChecklist && <OnboardingChecklist progress={data} />}
      {/* Future: stats cards, recent activity, etc. */}
      {!showChecklist && (
        <div className="flex min-h-[40vh] items-center justify-center text-sm text-gray-500">
          Dashboard
        </div>
      )}
    </div>
  );
}
